import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { toastr } from 'react-redux-toastr'
import moment from 'moment'
import CustomButton from '../../CustomButton'
import { Trans, useTranslation } from 'react-i18next'
import { getGlobalDataTags } from '../../../../../shared/api/action/CustomActions'
import { acceptSmsPhoneCallAgreement } from '../../../../../shared/api/action/AccountActions'

const sectionComponents = { ul: <ul />, li: <li />, a: <a />, br: <br />, strong: <strong /> };

const SMSAgreementModal = (props) => {
    const { t } = useTranslation('translation', { keyPrefix: 'accountPage.accountNotificationsContainer.notificationsModal.SMSAgreementModal' });
    const { hideSMSAgreementModal, agreeToSMS } = props;
    const rawSections = t('sections', { returnObjects: true });
    const sections = Array.isArray(rawSections) ? rawSections : [];
    const [agreementDate, setAgreementDate] = useState('');
    const [isAccepting, setIsAccepting] = useState(false);

    useEffect(() => {
        getGlobalDataTags()
            .then((res) => {
                const { tags } = res.data.response;
                setAgreementDate(tags.sms_agreement_date || '');
            })
            .catch(() => {
                toastr.error(t('toastrUnableGetAgreementDate'));
            });
    }, []);

    const onAgree = () => {
        setIsAccepting(true);
        acceptSmsPhoneCallAgreement(moment.utc().format('YYYYMMDDHHmmss'))
            .then(() => {
                setIsAccepting(false);
                agreeToSMS();
            })
            .catch((error) => {
                setIsAccepting(false);
                if (error.response?.status === 409) {
                    agreeToSMS();
                    return;
                }
                toastr.error(t('toastrUnableAcceptAgreement'));
            });
    };

    return (
        <Modal
            show={true}
            onHide={hideSMSAgreementModal}
            className="notifications-modal sms-agreement-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-lg">{t('titleSMSAgreement')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='agreement-modal-header'>
                    <img src='/images/rosco-logo-horizontal.png' />
                    {agreementDate && (
                        <p>
                            {t('effectiveDate', { date: agreementDate })}
                        </p>
                    )}
                </div>
                <div className='agreement-modal-body'>
                    {sections.map((section, index) => (
                        <div className='agreement-section' key={index}>
                            <h5>{section.heading}</h5>
                            <div className='agreement-section-body'>
                                <Trans components={sectionComponents}>{section.body}</Trans>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer>
                <CustomButton variant="delete" onClick={hideSMSAgreementModal} disabled={isAccepting}>{t('btnDisagree')}</CustomButton>
                <CustomButton variant="primary" onClick={onAgree} disabled={isAccepting}>{t('btnAgree')}</CustomButton>
            </Modal.Footer>
        </Modal>
    )
}

export default SMSAgreementModal;
